export const siteConfig = {
  name: "You&Me",
  appName: "You&Me - Indian Dating App",
  siteUrl: "https://indian-dating.app",
  siteDescription:
    "You&Me is the Indian dating app for NRIs worldwide, built for meaningful relationships rooted in culture, trust, and real intent.",
  ogImage: "https://indian-dating.app/og-image.jpg",
  logo: "https://indian-dating.app/img/new/logo.png",
  supportEmail: "admin@indian-dating.app",
  playStoreUrl:
    "https://play.google.com/store/apps/details?id=com.desidott.dating",
  appStoreUrl:
    "https://apps.apple.com/us/app/you-me-indian-dating-app/id6475261884",
  appStoreId: "6475261884",
  androidPackageName: "com.desidott.dating",
  facebookUrl: "https://www.facebook.com/profile.php?id=61572601719468",
  lastModified: "2026-03-06",
};

export const appStoreLinks = [
  {
    "@type": "EntryPoint",
    name: "Download You&Me on Google Play",
    urlTemplate: siteConfig.playStoreUrl,
    actionPlatform: "https://schema.org/AndroidPlatform",
  },
  {
    "@type": "EntryPoint",
    name: "Download You&Me on the App Store",
    urlTemplate: siteConfig.appStoreUrl,
    actionPlatform: "https://schema.org/IOSPlatform",
  },
];

export const mobileApplicationStructuredData = {
  "@context": "https://schema.org",
  "@type": "MobileApplication",
  "@id": `${siteConfig.siteUrl}/#mobile-app`,
  name: siteConfig.appName,
  alternateName: siteConfig.name,
  applicationCategory: "LifestyleApplication",
  operatingSystem: "iOS, Android",
  url: `${siteConfig.siteUrl}/download`,
  image: siteConfig.ogImage,
  description: siteConfig.siteDescription,
  downloadUrl: [siteConfig.playStoreUrl, siteConfig.appStoreUrl],
  installUrl: [siteConfig.playStoreUrl, siteConfig.appStoreUrl],
  sameAs: [siteConfig.playStoreUrl, siteConfig.appStoreUrl, siteConfig.facebookUrl],
  offers: {
    "@type": "Offer",
    price: "0",
    priceCurrency: "USD",
    availability: "https://schema.org/InStock",
  },
  potentialAction: {
    "@type": "InstallAction",
    name: "Download You&Me",
    target: appStoreLinks,
  },
};

export const downloadPageStructuredData = {
  "@context": "https://schema.org",
  "@type": "WebPage",
  "@id": `${siteConfig.siteUrl}/download#webpage`,
  name: "Download You&Me - Indian Dating App for NRIs",
  url: `${siteConfig.siteUrl}/download`,
  description:
    "Download You&Me on iOS or Android to meet Indian singles abroad.",
  mainEntity: {
    "@id": `${siteConfig.siteUrl}/#mobile-app`,
  },
  potentialAction: {
    "@type": "ViewAction",
    name: "Download the app",
    target: [
      `${siteConfig.siteUrl}/download`,
      siteConfig.playStoreUrl,
      siteConfig.appStoreUrl,
    ],
  },
};

export const homeStructuredData = [
  {
    "@context": "https://schema.org",
    "@type": "Organization",
    name: siteConfig.name,
    url: siteConfig.siteUrl,
    logo: siteConfig.logo,
    sameAs: [siteConfig.facebookUrl],
    contactPoint: [
      {
        "@type": "ContactPoint",
        email: siteConfig.supportEmail,
        contactType: "customer support",
        availableLanguage: ["English"],
      },
    ],
  },
  {
    "@context": "https://schema.org",
    "@type": "WebSite",
    name: siteConfig.appName,
    url: siteConfig.siteUrl,
    description: siteConfig.siteDescription,
  },
  mobileApplicationStructuredData,
  downloadPageStructuredData,
];
